<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100">ตั้งค่าใบแจ้งหนี้</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2">ลาน: <span class="font-bold text-amber-600">{{ siteState.selectedSite()?.name || '-' }}</span></p>
    </div>
    <div class="flex flex-wrap gap-3 items-center">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving() || isLoading()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center gap-2 disabled:opacity-50 bg-white/95 dark:bg-slate-900/95">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <button (click)="onRefresh()" class="p-3 bg-white/95 dark:bg-slate-900/95 rounded-2xl border"><span class="material-icons">refresh</span></button>
      <button *ngIf="canUpdate" (click)="onSave()" [disabled]="isSaving() || isLoading()"
        class="px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg disabled:opacity-50">
        {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
    </div>
  </div>

  <div class="relative bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 p-6 md:p-8">
    <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

    <ng-container *ngIf="config() as cfg">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">Prefix เลขที่ใบแจ้งหนี้</label>
          <input [(ngModel)]="cfg.invoiceNoPrefix" [disabled]="!canUpdate" class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700">
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">ครบกำหนดชำระ (วัน)</label>
          <input type="number" min="1" [(ngModel)]="cfg.defaultDueDays" [disabled]="!canUpdate" class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700">
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">ประเภทใบแจ้งหนี้เริ่มต้น</label>
          <select [(ngModel)]="cfg.defaultInvoiceType" [disabled]="!canUpdate" class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700">
            <option *ngFor="let opt of invoiceTypeOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">บัญชีธนาคารเริ่มต้น</label>
          <select [(ngModel)]="cfg.defaultBankAccountId" [disabled]="!canUpdate" class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700">
            <option [ngValue]="null">-- ไม่ระบุ --</option>
            <option *ngFor="let bank of banks()" [ngValue]="bank.id">{{ bank.bankName }} {{ bank.accountNumber }}</option>
          </select>
        </div>
        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 uppercase mb-2">External Notify URL</label>
          <input [(ngModel)]="cfg.externalNotifyUrl" [disabled]="!canUpdate" class="w-full px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700">
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
        <label class="flex items-center gap-3 p-4 rounded-xl border bg-slate-50 dark:bg-slate-800/40">
          <input type="checkbox" [(ngModel)]="cfg.enableThaiQr" [disabled]="!canUpdate">
          <span>เปิด Thai QR</span>
        </label>
        <label class="flex items-center gap-3 p-4 rounded-xl border bg-slate-50 dark:bg-slate-800/40">
          <input type="checkbox" [(ngModel)]="cfg.enableBankTransfer" [disabled]="!canUpdate">
          <span>เปิดแจ้งโอนเงิน</span>
        </label>
        <label class="flex items-center gap-3 p-4 rounded-xl border bg-slate-50 dark:bg-slate-800/40">
          <input type="checkbox" [(ngModel)]="cfg.enableStaffConfirm" [disabled]="!canUpdate">
          <span>Staff ยืนยันยอดได้</span>
        </label>
        <label class="flex items-center gap-3 p-4 rounded-xl border bg-slate-50 dark:bg-slate-800/40">
          <input type="checkbox" [(ngModel)]="cfg.allowBankTransferNotify" [disabled]="!canUpdate">
          <span>ลูกค้าแจ้งโอนผ่านระบบ</span>
        </label>
        <label class="flex items-center gap-3 p-4 rounded-xl border bg-slate-50 dark:bg-slate-800/40">
          <input type="checkbox" [(ngModel)]="cfg.status" [disabled]="!canUpdate">
          <span>เปิดใช้งาน config</span>
        </label>
      </div>
    </ng-container>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && config()?.id"
  [entityType]="activityEntityTypes.InvoiceSiteConfig"
  [entityId]="config()!.id!"
  title="ประวัติตั้งค่าใบแจ้งหนี้"
  [subtitle]="'#' + config()!.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
